import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';

/*
	Provider para se comunicar com o online e pegar os dados
*/

@Injectable()
export class ApiProvider {

	

	http: Http;
    /* Teste offline */
	// urlApi = 'https://localhost/Projetos/cartao-fidelidade/webservice/FRAMEWORK/apimarketplace2/index/';
    /* Teste online */
    // urlApi = 'https://homologa.cartaofidelidadedigital.com.br/apimarketplace2/index/';
    /* Produção */
    urlApi = 'https://assinante.cartaofidelidadedigital.com.br/apimarketplace2/index/';

    // Numero para modificarmos os itens na api
    versao = 2;

    // ID da Empresa
    empresa = 2;

	constructor(public _http: Http, public translate: TranslateService)
	{
    	this.http = _http;
  	}

  	/* Retorna a empresa */
  	public getIdEmpresa()
  	{
  		return this.empresa;
  	}

	// Envia dados por post
	private sendDados(page: string, dados: any)
	{
		dados.funcao = page;
		dados.empresa = this.empresa;
		dados.versao = this.versao;
		dados.lng = this.translate.getDefaultLang();

		let data = JSON.stringify(dados);
		return this.http.post(this.urlApi, data).map((res: Response) =>
	  	{

	  		let dados = res.json();
	  		if(dados['status'])
	  			return dados['dados'];
	  		else
	  			return false;
	  	});
	}

	// Cadastra o usuário
	public token(dados)
	{
		return this.sendDados('savePush', dados);
	}

	// Cadastra o usuário
	public cadastro(dados)
	{
		return this.sendDados('register', dados);
	}

	// Cadastra o usuário
	public login(dados)
	{
		return this.sendDados('login', dados);
	}

	// Verifica cadastro do usuario
	public verificaUsuario(dados)
	{
		return this.sendDados('verificaUsuario', dados);
	}

	// Retorna o logo da empresa
	public getLogo()
	{
		return this.sendDados('getLogo', {});
	}

	// Retorna as configuracoes da empresa
	public getConfig(dados)
	{
		return this.sendDados('getConfig', dados);
	}

	// Retorna todas as informações da empresa
	public getInformacoesEmpresa(dados)
	{
		return this.sendDados('getInformacoes', dados);
	}

	// Retorna quantidade de estrelas marcadas por um cliente especifico
	public getEstrelasMarcadas(dados)
	{
		return this.sendDados('getEstrela', dados);
	}

	// Verifica se a senha do admin está correta
	public checkAdmin(dados)
	{
		return this.sendDados('checkAdmin', dados);
	}

	// Salvar marcacao
	public salvaEstrela(dados)
	{
		return this.sendDados('salvaEstrela', dados);
	}

	// Retorna os dados do usuario 
	public dadosUser(dados)
	{
		return this.sendDados("getUsuario", dados);
	}

	// Salva novos dados para o usuario
	public saveUser(dados)
	{
		return this.sendDados("atualizaUsuario", dados);
	}

	// Retorna todas as notificações enviadas
	public getPush(dados)
	{
		return this.sendDados('getPush', dados);
	}

	// Verifica se o e-mail está cadastrado e envia um código de recuperação de senha
	public enviaRecuperarSenha(email)
	{
		let dados = {email:email, id_empresa_escolhida: 2};
		return this.sendDados("recuperarSenhaEmail", dados);
	}

	// Verifica se o codigo existe e de quem é
	public recuperaSenhaCodigo(cod)
	{
		return this.sendDados('getUsuariosByCod', {'cod':cod});
	}

	// Alteração de senha
	public alterarSenha(senha, id)
	{
		let dados = {nova:senha, id:id};
		return this.sendDados('alterarSenha', dados);
	}

	/* Historico */
	public getHistorico(dados)
	{
		return this.sendDados('getHistorico', dados);
	}

	/* Envia mensagem */
	public sendMensage(dados)
	{
		return this.sendDados('recebeMsg', dados);
	}

	/* Retorna todas as mensagens da conversa */
	public returnMensages(dados)
	{
		return this.sendDados('retornaMensagens', dados);
	}

	/* Verifica se o id do facebook tem login com essa empresa*/
	public cadfacebook(id, nome, email)
	{
		let dados = {id: id, nome: nome, email: email, id_empresa: this.empresa};
		return this.sendDados('cadfacebook', dados);
	}

	// Pegar os estados e cidades dos clientes marketplace
	public getEnderecosMarketplace()
	{
		return this.sendDados('getEnderecosMarketplace', []);
	}

	// Pega lojas dessa cidade/estado
	public getLojasEndereco(endereco)
	{
		return this.sendDados('getLojasMarketplace', endereco);
	}

	// Pega lojas dessa cidade/estado
	public relacionaCliente(dados)
	{
		return this.sendDados('relacionaCliente', dados);
	}

	// Pega lojas dessa cidade/estado
	public tiraRelacaoCliente(dados)
	{
		return this.sendDados('tiraRelacaoCliente', dados);
	}

	// Pega lojas dessa cidade/estado
	public setPontoQrcode(dados)
	{
		return this.sendDados('setPontoQrcode', dados);
	}

	// Pega lojas dessa cidade/estado
	public zerarPontoQrcode(dados)
	{
		return this.sendDados('zerarCartaoPeloQRcode', dados);
	}

	// Pega lojas dessa cidade/estado
	public getMinhasLojas(dados)
	{
		return this.sendDados('getMinhasLojas', dados);
	}

	// Busca empresas
	public getEmpresasBusca(dados)
	{
		return this.sendDados('getEmpresasBusca', dados);
	}

	// Busca empresas
	public getFiltrosEmpresas(dados)
	{
		return this.sendDados('getFiltrosEmpresas', dados);
	}

	// Busca empresas
	public getFiltroFuncao(dados)
	{
		return this.sendDados('getFiltroFuncao', dados);
	}

	public changeLanguage(dados)
	{
		return this.sendDados('changeLanguage', dados);
	}

	// marca mensagem como lida
	public visualizaMsg(dados)
	{
		return this.sendDados('visualizaMsg', dados);
	}

	/* Retorna mensagens da conversa */
	public getMaisMensagens(dados)
	{
		return this.sendDados('getMsg', dados);
	}

	/* QrCode empresa */
	public setPontoQrcodeEmpresa(dados)
	{
		return this.sendDados('setPontoQrcodeEmpresa', dados);
	}

	/* QrCode empresa */
	public share(dados)
	{
		return this.sendDados('share', dados);
	}

	public getMyPoint(dados)
	{
		return this.sendDados('getMyPoint', dados);
	}
}


// WEBPACK FOOTER //
// ./src/providers/api/api.ts